export const OAUTH_QS_KEY = 'oAuthParams';
export const RECAPTCHA_STORAGE_KEY = 'recaptcha';
